module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"settingsTemplates":"Template Settings","editor":"The Email Editor"}}')
  delete Component.options._Ctor
}
